export function sectorMapDivision(map) {
    //separar mapa en areas de trabajo
    const cuadrantes = [
        [
            [
                { lat: 3.1751961162146824e1, lng: -1.0650278214237032e2 },
                { lat: 3.1742942598298043e1, lng: -1.0650278214237032e2 },
                { lat: 3.174293910128239e1, lng: -1.0640779196560459e2 },
                { lat: 3.1751957228009818e1, lng: -1.0640779196560459e2 }
            ],
            [
                { lat: 3.1742943472859125e1, lng: -1.065238931169125e2 },
                { lat: 3.1733924896232562e1, lng: -1.0652389311691249e2 },
                { lat: 3.1733919652544124e1, lng: -1.063866983816751e2 },
                { lat: 3.1742937792204735e1, lng: -1.063866983816751e2 }
            ],
            [
                { lat: 3.1733924896539563e1, lng: -1.065238951618222e2 },
                { lat: 3.172490630713594e1, lng: -1.065238951618222e2 },
                { lat: 3.1724900628461164e1, lng: -1.063761613001228e2 },
                { lat: 3.1733918781052356e1, lng: -1.063761613001228e2 }
            ],
            [
                { lat: 3.1724905870775242e1, lng: -1.0651334580879734e2 },
                { lat: 3.1715887268595992e1, lng: -1.0651334580879735e2 },
                { lat: 3.171588202857663e1, lng: -1.0637617765206433e2 },
                { lat: 3.1724900194095724e1, lng: -1.0637617765206433e2 }
            ],
            [
                { lat: 3.1715887269056307e1, lng: -1.0651334887341302e2 },
                { lat: 3.1706868654103964e1, lng: -1.0651334887341304e2 },
                { lat: 3.170686297940327e1, lng: -1.0636564362188955e2 },
                { lat: 3.1715881157848894e1, lng: -1.0636564362188955e2 }
            ],
            [
                { lat: 3.1706867781840145e1, lng: -1.0649225322800538e2 },
                { lat: 3.16978491541155e1, lng: -1.0649225322800538e2 },
                { lat: 3.169784391776398e1, lng: -1.0635511162659851e2 },
                { lat: 3.1706862109134114e1, lng: -1.0635511162659851e2 }
            ],
            [
                { lat: 3.16978491548824e1, lng: -1.064922583311203e2 },
                { lat: 3.1688830514388652e1, lng: -1.0649225833112028e2 },
                { lat: 3.1688825279870496e1, lng: -1.0635512999780744e2 },
                { lat: 3.1697843484162487e1, lng: -1.0635512999780744e2 }
            ],
            [
                { lat: 3.1688830079098974e1, lng: -1.0648171611848515e2 },
                { lat: 3.1679811425837492e1, lng: -1.0648171611848514e2 },
                { lat: 3.1679807065266523e1, lng: -1.0636569567365228e2 },
                { lat: 3.1688825282477744e1, lng: -1.0636569567365228e2 }
            ],
            [
                { lat: 3.1679810554949924e1, lng: -1.06460629649373e2 },
                { lat: 3.1670791888922114e1, lng: -1.0646062964937299e2 },
                { lat: 3.1670788837591473e1, lng: -1.0637625930189958e2 },
                { lat: 3.167980706771988e1, lng: -1.0637625930189958e2 }
            ],
            [
                { lat: 3.16707918901486e1, lng: -1.064606378033808e2 },
                { lat: 3.1661773211357662e1, lng: -1.0646063780338078e2 },
                { lat: 3.1661769725344172e1, lng: -1.0636573033595083e2 },
                { lat: 3.167078796838899e1, lng: -1.0636573033595083e2 }
            ],
            [
                { lat: 3.166177321258381e1, lng: -1.0646064595373298e2 },
                { lat: 3.1652754521031735e1, lng: -1.06460645953733e2 },
                { lat: 3.1652751471838542e1, lng: -1.0637629191061461e2 },
                { lat: 3.166176972779654e1, lng: -1.0637629191061461e2 }
            ]
        ],
    ];
    const polygonStyles = [
        {
        fillColor: 'blue',
        fillOpacity: 0.08,
        //strokeColor: 'blue',
        strokeWeight: 0,
        },
    ];
    for (let i = 0; i < cuadrantes.length; i++) {
        const polygon = new google.maps.Polygon({
            paths: cuadrantes[i],
            fillColor: polygonStyles[0].fillColor,
            fillOpacity: polygonStyles[0].fillOpacity,
            //strokeColor: polygonStyles[0].strokeColor,
            strokeWeight: polygonStyles[0].strokeWeight,
        });
        polygon.setMap(map);
    }
}